import { inject, Injectable } from '@angular/core';

// Service
import { ApiService } from './api.service';
import { lastValueFrom } from 'rxjs';
import { IModificarPdf } from '../interface/modificar.interface';

@Injectable({
  providedIn: 'root',
})
export class PdfService { 
  // Services
  private apiService = inject(ApiService);  

  // Methods
  async getListPages(idfdArchivo: number) {
    return await lastValueFrom(this.apiService.GetPages(idfdArchivo));
  }

  async getBackup(IdfdArchivo: number) {
    return await this.apiService.GetBackup(IdfdArchivo);
  }

  async getPage(Id: number) {
    return await this.apiService.GetPage(Id);
  }

  async updateModify(pages: IModificarPdf[]) {
    return await lastValueFrom(this.apiService.PutUpdate(pages));
  }

  async getPreview(idfdArchivo: number) {
    return await lastValueFrom(this.apiService.GetPreview(idfdArchivo));
  }

  async publish(idfdArchivo: number, description: string) {
    return await lastValueFrom(this.apiService.PostPublish(idfdArchivo, description));
  }

  async addFile(idfdArchivo: number, base64: string, extension: string) {
    return await lastValueFrom(this.apiService.PostAddFile(idfdArchivo, base64, extension));
  }
}
